import * as React from 'react'
import CardModel from '../models/Card'
import HeroModel from '../models/Hero'
import SwipeHelper from '../utils/SwipeHelper'
import Card from './Card'
import Game from './Game'

interface IHeroProps {
  model: HeroModel
}

export default class Hero extends React.Component<IHeroProps> {
  hero: HeroModel

  constructor(props: IHeroProps) {
    super(props)
    this.hero = this.props.model

    this.initEvents()
  }

  initEvents() {
    SwipeHelper.instance.events.swiped.deleteAll()
    SwipeHelper.instance.events.swiped.add((event, direction) => {
      this.hero.move(direction!)
      Game.refresh()
    })
  }

  selectSpell(spell: CardModel) {
    if (this.hero.selectedSpell === spell) {
      delete this.hero.selectedSpell
    } else {
      this.hero.selectedSpell = spell
    }

    Game.refresh()
  }

  renderSpells() {
    return this.hero.spells.cards.map(spell =>
      <Card model={spell} key={spell.id}
        className={`hero-spell ${spell === this.hero.selectedSpell ? 'selected': ''}`}
        onClick={() => this.selectSpell(spell)}
      />
    )
  }

  render() {
    return (
      <div className='footer'>
        <hr/>
        <br/>
        {this.renderSpells()}
      </div>
    )
  }
}
